module.exports = __webpack_public_path__ + "static/mjs-fair-work-30108ed5ac773234a4b14f0d96547224.svg";